import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-maximize-sidebar-button',
    templateUrl: './maximize-sidebar-button.component.html',
    styleUrls: ['./maximize-sidebar-button.component.scss'],
    standalone: false,
})
export class MaximizeSidebarButtonComponent {}
